/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in popup MST_005
 * @created at      :   2026/01/21
 * @created by      :   longvv
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import repository from './repository';

const dataInit = {
    department_cd: '',
    department_name: '',
    center_cd: '',
    mode: 0,
    pageSize: 10,
    pageNo: 1
};

export default {
    namespaced: true,
    state: {
        listData: [],
        data: { ...dataInit },
        msgNoData: '該当するデータが存在しません',
        totalRows: 0
    },
    mutations: {
        resetDataInit(state) {
            state.data = { ...dataInit };
            state.listData = [];
            state.totalRows = 0;
            state.msgNoData = '該当するデータが存在しません';
        },
        setListData(state, data) {
            state.listData = data ?? [];
            state.msgNoData = '';
        },
        setTotalRows(state, data) {
            state.page_no = data.page ?? [];
            state.page_size = data.pagesize ?? [];
            state.totalRows = data.total_rows;
        },
        setPageNavigation(state, data) {
            state.data.pageNo = data.currentPage;
            state.data.pageSize = data.perPage;
        },
        setPageNo(state, data) {
            state.data.pageNo = data;
        },
        setMessage(state, data) {
            state.msgNoData = data;
        }
    },
    actions: {
        /**
         * search area info
         * -----------------------------------------
         * @author : hainn - 2024/10/16 - create
         * @params :
         * @access : private
         */
        searchAreaInfo(context, param) {
            try {
                repository.searchAreaInfo(param).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        const listData = data.Data.data;
                        if (listData.length > 0) {
                            context.commit('setListData', listData);
                        } else {
                            context.commit('setListData', []);
                            context.commit('setMessage', '該当するデータが存在しません');
                        }
                        if (param.callback) {
                            param.callback(data);
                        }
                        context.commit('setTotalRows', data.Data.paging);
                    }
                });
            } catch (e) {
                console.log('searchAreaInfo: ' + e.message);
            }
        },
        searchGroupInfo(context, param) {
            try {
                const departmentCd = param.department_cd ? Number(param.department_cd) : 0;
                const groupCd = param.group_cd ? Number(param.group_cd) : 0;
                const companyCd = param.company_cd ? Number(param.company_cd) : 0;
                const searchParam = {
                    company_cd_from: companyCd || 0,
                    company_cd_to: companyCd || 0,
                    department_cd_from: departmentCd || 0,
                    department_cd_to: departmentCd || 0,
                    group_cd_from: groupCd || 0,
                    group_cd_to: groupCd || 0,
                    group_name: param.group_name ?? '',
                    pageNo: param.pageNo ?? 1,
                    pageSize: param.pageSize ?? 10,
                    col: '',
                    sort: ''
                };
                repository.searchGroupInfo(searchParam).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        const listData = data.Data?.result ?? [];
                        if (listData.length > 0) {
                            context.commit('setListData', listData);
                        } else {
                            context.commit('setListData', []);
                            context.commit('setMessage', '該当するデータが存在しません');
                        }
                        if (param.callback) {
                            param.callback(data);
                        }
                        const paging = data.Data?.paging?.[0] ?? {
                            total_rows: 0,
                            page: 1,
                            pagesize: searchParam.pageSize
                        };
                        context.commit('setTotalRows', paging);
                    }
                });
            } catch (e) {
                console.log('searchGroupInfo: ' + e.message);
            }
        }
    }
};
